"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
exports.ErrorMessage = {
    WINDOW_IS_NOT_DEFINED: 'Window is not defined',
    URL_IS_NOT_DEFINED: 'Url is not defined',
    TIMEOUT: 'Timeout',
};
